module.exports = __webpack_public_path__ + "img/intellectual_property.83a42647.jpg";